import { debug } from 'debug/src/browser';
import type { Debugger } from 'debug';

interface ILoggersObject {
    [name: string]: Debugger
};

type Path = `${ 'components/' | 'utils/' | 'helpers/' }${string}.${ 'tsx' | 'ts' | 'js' }`;
interface ILoggerSettings {
    pathToCurrentFile: Path
    loggersList?: Array<String>
    prefix?: String
    suffix?: String
};

const defaultLoggerObject = ['debug', 'info', 'warn', 'err'];
const loggerStyles = {
  errColor: 'red',
  warnColor: 'orange',
  infoColor: 'blue',
  debugColor: 'purple',
};

export const makeLogger = ({
  pathToCurrentFile,
  loggersList = defaultLoggerObject,
  prefix,
  suffix
}: ILoggerSettings): ILoggersObject => {
    const obj = {};

    prefix = prefix ? `${prefix} ` : '';
    suffix = suffix ? ` ${suffix}` : '';

    for (let i = 0; i < loggersList.length; i++) {
      const loggerName = loggersList[i].toString();
      const loggerValue = debug(`${prefix}${loggersList[i].toUpperCase()}:${pathToCurrentFile}${suffix}`);

      loggerValue.color = loggerStyles[`${loggerName}Color`];
      loggerValue.log = console.log.bind(console); //eslint-disable-line no-console
      obj[loggerName] = loggerValue;
    };

    return obj;
};
